import AxiosInstance from "./AxiosInstance";

// Get All Destinations
export const getAllPaymentDetails = async () => {
  try {
    const { data } = await AxiosInstance.get("/payment_details");
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const deletePaymentDetails = async (user) => {
  try {
    const { data } = await AxiosInstance.delete(`/payment_details/${user._id}`);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
